module.exports = __webpack_public_path__ + "static/img/9.ec929b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/7/9.png
// module id = 287
// module chunks = 0